<template>
  <div class="corrupt-balloon">
    <div class="messsage">
      <slot></slot>
    </div>
    <svg
      width="24"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      class="curve"
    >
      <path
        d="M2.767 4.823C.294 1.356.45-1.112.294.51c-1.949 20.089 5.794 23.047 23.103 16.1-10.766 0-14.264-2.859-20.63-11.786z"
        fill="#3C3C3C"
        fill-rule="evenodd"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CorruptBalloon',
  mounted () {
    setTimeout(() => {
      this.$emit('showReply')
    }, 2500)
  }
}
</script>

<style lang="scss" scoped>
@keyframes arrive {
  from {
    opacity: 0;
    transform: translateY(5px) scale(0.6);
  }
  to {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

.corrupt-balloon {
  background-color: #3C3C3C;
  font-size: 16px;
  line-height: 1.19;
  border-radius: 10px;
  padding: 14px 18px 14px 25px;
  text-align: left;
  margin-bottom: 19px;
  position: relative;
  color: white;
  animation: arrive 400ms forwards;
  opacity: 1;
  transform: translateY(0px) scale(1);
  max-width: 325px;
  margin-left: auto;
}
.message {
}
.curve {
  position: absolute;
  right: -17px;
  bottom: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/CorruptBalloon.vue